import {Command} from '@application/command/command';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ParametersForEditingProductionScheduleItem} from '@presentation/pages/texfab/production-schedule/add/plan/parameters-for-editing-production-schedule-item';

export class EditProductionScheduleItemCommand implements Command<ParametersForEditingProductionScheduleItem, ProductionSchedule> {
  public execute(commandArgs: ParametersForEditingProductionScheduleItem): ProductionSchedule {
    const {productionSchedule, productionScheduleItemInPathGroup, productionScheduleItemInPathGroupIndex, productionSchedulePathIndex, startDentOfColoredYarnSet} = commandArgs;

    const productionSchedulePathsOfColoredYarnSet = productionSchedule.getProductionSchedulePathsOfColoredYarnSetAtStartDent(startDentOfColoredYarnSet);
    const productionSchedulePath = productionSchedulePathsOfColoredYarnSet.getProductionSchedulePathAt(productionSchedulePathIndex);
    productionSchedulePath.setProductionScheduleItemInPathGroupAt(productionScheduleItemInPathGroupIndex, productionScheduleItemInPathGroup);

    return productionSchedule;
  }
}
